// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getWeeklyCommitmentReliability(projectId: string, week?: string): Promise<Object> {
  const url: string = week ? `${getBaseUrl()}projects/${projectId}/insights/commitment/weekly/${week || ''}` : `${getBaseUrl()}projects/${projectId}/insights/commitment`;
  return axios.get(url);
}
